import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react'
import { InteractionType } from '@azure/msal-browser'
import { ThemeProvider } from '@mui/material/styles'
import { CssBaseline, StyledEngineProvider } from '@mui/material'

// defaultTheme
import themes from 'themes'

// project imports
import NavigationScroll from 'layout/NavigationScroll'
import LanguageSync from 'i18n/LanguageSync'

// auth
import AuthenticationController from 'auth/AuthController'
import MobileAppPrompt from './ui-component/MobileAppPrompt'

// ==============================|| PAGES ||============================== //
const Pages = () => {
  const customization = useSelector((state) => state.customization)

  return (
    <StyledEngineProvider injectFirst>
      <LanguageSync />
      <ThemeProvider theme={themes(customization)}>
        <CssBaseline />
        <MobileAppPrompt />
        <AuthenticationController>
          <NavigationScroll />
        </AuthenticationController>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

// ==============================|| APP ||============================== //
const App = ({ instance }) => {
  return (
    <MsalProvider instance={instance}>
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
        <Pages />
      </MsalAuthenticationTemplate>
    </MsalProvider>
  )
}

App.propTypes = {
  instance: PropTypes.object,
}

export default App
